'use strict';

const CLASS_STATUS_ONLY = 'is-status-only';
const CLASS_LOADING = 'is-loading';
const CLASS_SUCCESS = 'is-success-animate';
const CLASS_ERROR = 'is-error-animate';

class Button {
    constructor(element) {
        this.$element = element;
        this.$text = element.querySelector('.button-status__text');
        this.originalText = this.$text.innerHTML;
        this.messages = this.$element.dataset.messages
            ? JSON.parse(this.$element.dataset.messages)
            : {};
    }

    setLoading() {
        this.$element.disabled = true;
        this.$element.classList.add(CLASS_STATUS_ONLY);
        this.$element.classList.add(CLASS_LOADING);
    }

    removeLoading() {
        this.$element.disabled = false;
        this.$element.classList.remove(CLASS_STATUS_ONLY);
        this.$element.classList.remove(CLASS_LOADING);
    }

    setSuccess(message = null, timeout = null) {
        this.$element.disabled = true;
        this.$element.classList.remove(CLASS_LOADING, CLASS_ERROR);

        if (message) {
            this.$element.classList.remove(CLASS_STATUS_ONLY);
            this.$text.innerHTML = message;
        } else {
            this.$element.classList.add(CLASS_STATUS_ONLY);
        }

        this.$element.classList.add(CLASS_SUCCESS);

        if (timeout) {
            setTimeout(() => {
                this.removeSuccess();
            }, timeout);
        }
    }

    removeSuccess() {
        this.$element.disabled = false;
        this.$element.classList.remove(CLASS_STATUS_ONLY);
        this.$element.classList.remove(CLASS_SUCCESS);
        this.$text.innerHTML = this.originalText;
    }

    setError(message = null, timeout = null) {
        this.$element.disabled = true;
        this.$element.classList.remove(CLASS_LOADING, CLASS_SUCCESS);

        if (message) {
            this.$element.classList.remove(CLASS_STATUS_ONLY);
            this.$text.innerHTML = message;
        } else {
            this.$element.classList.add(CLASS_STATUS_ONLY);
        }

        this.$element.classList.add(CLASS_ERROR);

        if (timeout) {
            setTimeout(() => {
                this.removeError();
            }, timeout);
        }
    }

    removeError() {
        this.$element.disabled = false;
        this.$element.classList.remove(CLASS_STATUS_ONLY);
        this.$element.classList.remove(CLASS_ERROR);
        this.$text.innerHTML = this.originalText;
    }
}

module.exports = Button;
